// Quick View Setup
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function getShippingTaxProperties(tags) {
  var properties = {};

  if (!tags || !tags.length) {
    return properties;
  }

  tags.forEach(function(tag) {
    var lowerTag = tag.toLowerCase();

    if (lowerTag.indexOf('dhlcode:') !== -1) {
      var dhlcode = lowerTag.split('dhlcode:')[1];
      if (dhlcode) {
        properties.__dhlcode = dhlcode;
      }
    }

    if (lowerTag.indexOf('dhldes:') !== -1) {
      var dhldes = lowerTag.split('dhldes:')[1];
      if (dhldes) {
        properties.__dhldes = dhldes;
      }
    }

    if (lowerTag.indexOf('item_tax_rate:') !== -1) {
      var itemTaxRate = lowerTag.split('item_tax_rate:')[1];
      if (itemTaxRate) {
        properties.__item_tax_rate = itemTaxRate;
      }
    }
  });

  return properties;
}

function quickView() {
  $(".quick-view").click(function () {
    // cart
    var cart_item_qty = '';
    var varid = '';
    var varqty = '';
    // default
    var vid_default= '';
    var changed_varient_id='';

    fetch('/cart.js', {})
    .then((get_res)=>{
      return get_res.json();
    })
    .then((new_get_res)=>{
      console.log(new_get_res);
      cart_item_qty = new_get_res.items;
      for(let i=0; i<cart_item_qty.length; i++ ){
        varqty = cart_item_qty[i].quantity;
        varid = cart_item_qty[i].id;
        console.log(varid +'cartid');
        console.log(varqty + 'cartqty');
      }
    });

    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      console.log(product);

      var title = product.title;
      var type = product.type;
      var price = product.price/100;
      var original_price = product.compare_at_price/100;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;

      $('.qv-product-title').text(title);
      if(original_price){
        $('.qv-product-original-price').text(`RS. ${original_price}`);
      }
      $('.qv-product-price').text(`RS. ${price}`);
      $('.qv-product-type').text(type);

      $(product.tags).each(function (i,tag) {
        if(tag =='Pre Order'){
          console.log("product-Tag",tag,i);
          $('.qv-add-button').val("pre order");
        }
      });

      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);

      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });

      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
    });

    $(document).on("change", "#quick-view select", function (i) {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            var v_id = v.id;

            $('.qv-product-price').text('Rs.' + price);
            $('.qv-product-original-price').text('Rs.' + original_price);
            changed_varient_id = v_id;

            if (v.inventory_policy == 'continue') {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else{
              $('.qv-add-button').prop('disabled', true).val('Sold Out');
            }
          }
        });
      });
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        
        // Unbind duplicate handlers
        $(document).off("click", ".qv-add-button").on("click", ".qv-add-button", function (event) {
          event.preventDefault();
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';

          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });

          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions || product.variants.length === 1) {
                var_id = v.id;
                var obj = {
                  id: var_id,
                  quantity: parseInt(qty)
                };
                
                var isFlag = false;

                fetch('/cart.js', { method: 'GET' })
                .then(response => response.json())
                .then(result => {
                  if (result.items.length > 0) {
                    $(result.items).each(function(index, value) {
                      let qty = value.quantity + parseInt(obj.quantity);
                      let v_id = parseInt(obj.id);

                      if(value.id == v_id) {
                        if (qty <= 5) {
                          isFlag = true;
                        } else {
                          if ($(".shopify-product-form .qty-note").length == 0) {
                            $(".shopify-product-form .quantity").after("<div class='qty-note'> You can not add more than 5 items.</div>");
                            $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>Item Limit can not exceed upto 5.</span>');
                          }
                          isFlag = false;
                        }
                        return false;
                      } else {
                        if(obj.quantity <= 5){
                          isFlag = true;
                        }
                      }
                    });
                  } else { 
                    if(obj.quantity <= 5){
                      isFlag = true;
                    }
                  }
                  
                  if (isFlag) {
                    processCart(var_id, qty, getShippingTaxProperties(product.tags));
                  }
                });
              }
            });
          });

          // Custom Add To Cart Function with Cart Slider Trigger
          function processCart(var_id, qty, properties) {
            var data = {
              quantity: qty,
              id: var_id
            };

            if (properties && Object.keys(properties).length > 0) {
              data.properties = properties;
            }

            jQuery.post('/cart/add.js', data, null, "json")
            .done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart.</span>');
              
              // 1. Close QuickView Popup
              $.fancybox.close();

              // 2. Open Cart Drawer Slider
              if (typeof openCartDrawer === 'function') {
                openCartDrawer();
              }
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + (data ? data.description : 'Failed to add'));
            });
          }

        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
}

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});